import type { TranslationsKeys } from "@onesolution/hooks/useLanguage";
import { FEATURE_FLAGS } from "./front";
import { USER_ROLES } from "./monday/users";

export const SIDEBAR_WIDTH = 288;

export const SIDEBAR_ROUTES = [
	{
		key: "operations",
		name: "name.operations",
		path: "/app/operations",
		icon: "solar:clipboard-text-line-duotone",
		iconActive: "solar:clipboard-text-bold-duotone",
		roles: [],
		children: [],
		isDisabled: false,
	},
	{
		key: "tasks",
		name: "name.tasks",
		path: "/app/tasks",
		icon: "solar:checklist-minimalistic-line-duotone",
		iconActive: "solar:checklist-minimalistic-bold-duotone",
		children: [],
		roles: [],
		isDisabled: false,
	},
	{
		key: "planning",
		name: "name.planning",
		path: "/app/planning",
		icon: "solar:calendar-line-duotone",
		iconActive: "solar:calendar-bold-duotone",
		children: [],
		roles: [],
		isDisabled: false,
	},
	{
		key: FEATURE_FLAGS.files,
		name: "name.files",
		path: "/app/files",
		icon: "solar:folder-with-files-line-duotone",
		iconActive: "solar:folder-with-files-bold-duotone",
		children: [],
		roles: [],
		isDisabled: false,
	},
	{
		key: FEATURE_FLAGS.analytics,
		name: "name.analytics",
		path: "/app/analytics",
		icon: "solar:pie-chart-2-line-duotone",
		iconActive: "solar:pie-chart-2-bold-duotone",
		roles: [],
		isDisabled: false,
		children: [
			{
				key: "analytics.overview",
				name: "basic.overview",
				path: "/app/analytics/overview",
				icon: "solar:chart-line-duotone",
				iconActive: "solar:chart-bold-duotone",

				roles: [],
				isDisabled: false,
			},
			{
				key: "analytics.operations",
				name: "name.operations",
				path: "/app/analytics/operations",
				icon: "solar:notes-line-duotone",
				iconActive: "solar:notes-bold-duotone",
				roles: [],
				isDisabled: false,
			},
		],
	},
	{
		key: "team-members",
		name: "name.team-members",
		path: "/app/users",
		icon: "solar:users-group-rounded-line-duotone",
		iconActive: "solar:users-group-rounded-bold-duotone",
		children: [],
		isDisabled: false,
		roles: [USER_ROLES.Admin],
	},
] as const;

export type SidebarRouteType = {
	key: string;
	name: TranslationsKeys;
	path: string;
	icon: string;
	iconActive: string;
	isDisabled: boolean;
	roles: readonly USER_ROLES[];
	children?: readonly SidebarRouteType[];
	isChild?: boolean;
	custom?: boolean;
};
